'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { H2 } from 'foundations-components/transitional/components/H2';

/**
 * @param {Object} props
 * @param {Function} props.onConfirm (required)
 * @param {string} props.messageKey (required)
 * @param {boolean} props.hasModulesInFlexColumn (required)
 * @param {boolean} props.shouldShowRestore (required)
 * @param {Function} props.onRestore (required)
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ForceTemplateSwapModal extends Component {
  renderFlexColumnMessage() {
    const {
      hasModulesInFlexColumn
    } = this.props;
    if (hasModulesInFlexColumn) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Alert, {
          type: 'warning',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "templateMissing.columnWarning"
          })
        })]
      });
    }
    return null;
  }
  render() {
    const {
      onConfirm,
      messageKey,
      shouldShowRestore,
      onRestore
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'templateMissing.header'
          })
        })
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `templateMissing.${messageKey}`
        }), this.renderFlexColumnMessage()]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: onConfirm,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "templateMissing.button"
          })
        }), shouldShowRestore && /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: onRestore,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "templateMissing.restore"
          })
        })]
      })]
    });
  }
}